import { JSX } from 'react';
import favMetrics from '../../juristec-ui/assets/logo.svg';
import favThomson from '../../juristec-ui/assets/icon-thomson.svg';
import favBenner from '../../juristec-ui/assets/fav_benner.svg';
import getManifest from './manifests';

const getBlob = (system: string): string => {
  const blob = new Blob([getManifest(system)], {
    type: 'application/json',
  });
  return URL.createObjectURL(blob);
};

const Head = (): JSX.Element => (
  <>
    {process.env.REACT_APP_FIREBASE_PROJECT_LABEL === 'legalone-analytics' && (
      <>
        <title>Legal One Analytics</title>
        <meta name="description" content="Legal One Analytics, seu assistente de BI Jurídico" />
        <link rel="icon" id="favicon" href={favThomson} />
        <link rel="apple-touch-icon" href={favThomson} />
        <link rel="manifest" href={getBlob('legalone-analytics')} />
      </>
    )}
    {process.env.REACT_APP_FIREBASE_PROJECT_LABEL === 'benner-metrics' && (
      <>
        <title>Benner Metrics</title>
        <meta name="description" content="Benner Metrics, seu assistente de BI Jurídico" />
        <link rel="icon" id="favicon" href={favBenner} />
        <link rel="apple-touch-icon" href={favBenner} />
        <link rel="manifest" href={getBlob('benner-metrics')} />
      </>
    )}
    {process.env.REACT_APP_FIREBASE_PROJECT_LABEL === 'legalmetrics' && (
      <>
        <title>Legal Metrics</title>
        <meta name="description" content="Legal Metrics, seu assistente de BI Jurídico" />
        <link rel="icon" id="favicon" href={favMetrics} />
        <link rel="apple-touch-icon" href={favMetrics} />
        <link rel="manifest" href={getBlob('legalmetrics')} />
      </>
    )}
  </>
);

export default Head;
